module.exports = __webpack_public_path__ + "img/SER-i-2-I.ec055202.png";